import styled from 'styled-components'

export default styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
`
